var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"week-days flex",class:{'is-dark': _vm.dark}},_vm._l((_vm.weekDays),function(weekDay,index){return _c('div',{key:index,staticClass:"flex-1 text-muted lm-fs-12 flex justify-content-center align-center week-days-container"},[_vm._v(" "+_vm._s(weekDay)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }